import { ReactNode } from 'react';
import { Info } from 'lucide-react';

function Notice({
  children,
  icon,
  className = '',
}: {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-2 rounded-xl border border-green-200 bg-green-50/80 px-4 py-2 text-center text-sm font-medium text-green-900 ${className}`}
    >
      {icon ?? <Info className="h-4 w-4 shrink-0 text-green-700" />}
      {children}
    </div>
  );
}

export default Notice;
